import { isBlank } from "utils/common";

import { SelectSaleConfigurationValues } from "./word-processor-select-sale-configuration-dialog.component";

/**
 * Helper function to normalize a boolean value with default to true
 * @param value The value to check
 * @returns true if value is blank, otherwise the boolean conversion of the value
 */
function normalizeBooleanWithDefault(
  value?: string | number | null | boolean | object
): boolean {
  return isBlank(value) ? true : Boolean(value);
}

export function createDefaultValues(
  data: SelectSaleConfigurationValues
): SelectSaleConfigurationValues {
  return {
    // general
    include_totals: normalizeBooleanWithDefault(data.include_totals),
    include_hearing_aids: normalizeBooleanWithDefault(
      data.include_hearing_aids
    ),
    include_domes: normalizeBooleanWithDefault(data.include_domes),
    include_receivers: normalizeBooleanWithDefault(data.include_receivers),
    include_tubes: normalizeBooleanWithDefault(data.include_tubes),
    include_earmolds: normalizeBooleanWithDefault(data.include_earmolds),
    include_chargers: normalizeBooleanWithDefault(data.include_chargers),
    include_batteries: normalizeBooleanWithDefault(data.include_batteries),
    include_remotes: normalizeBooleanWithDefault(data.include_remotes),
    include_others: normalizeBooleanWithDefault(data.include_others),
    include_services_dispensing_fees: normalizeBooleanWithDefault(
      data.include_services_dispensing_fees
    ),

    // hearing aids
    hearing_aids_show_product: normalizeBooleanWithDefault(
      data.hearing_aids_show_product
    ),
    hearing_aids_show_manufacturer: normalizeBooleanWithDefault(
      data.hearing_aids_show_manufacturer
    ),
    hearing_aids_show_model: normalizeBooleanWithDefault(
      data.hearing_aids_show_model
    ),
    hearing_aids_show_color: normalizeBooleanWithDefault(
      data.hearing_aids_show_color
    ),
    hearing_aids_show_battery: normalizeBooleanWithDefault(
      data.hearing_aids_show_battery
    ),
    hearing_aids_show_serial: normalizeBooleanWithDefault(
      data.hearing_aids_show_serial
    ),
    hearing_aids_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.hearing_aids_show_mfr_warranty_exp
    ),
    hearing_aids_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.hearing_aids_show_lnd_warranty_exp
    ),
    hearing_aids_show_service_plan_exp: Boolean(
      data.hearing_aids_show_service_plan_exp
    ),
    hearing_aids_show_lnd_deductible: normalizeBooleanWithDefault(
      data.hearing_aids_show_lnd_deductible
    ),
    hearing_aids_show_price: normalizeBooleanWithDefault(
      data.hearing_aids_show_price
    ),
    hearing_aids_show_quantity: normalizeBooleanWithDefault(
      data.hearing_aids_show_quantity
    ),
    hearing_aids_show_patient_resp: normalizeBooleanWithDefault(
      data.hearing_aids_show_patient_resp
    ),
    hearing_aids_show_insurance_resp: normalizeBooleanWithDefault(
      data.hearing_aids_show_insurance_resp
    ),
    hearing_aids_show_managed_care_resp: normalizeBooleanWithDefault(
      data.hearing_aids_show_managed_care_resp
    ),
    hearing_aids_show_cpt_code: normalizeBooleanWithDefault(
      data.hearing_aids_show_cpt_code
    ),
    hearing_aids_show_ear: normalizeBooleanWithDefault(
      data.hearing_aids_show_ear
    ),

    // domes
    domes_show_product: normalizeBooleanWithDefault(data.domes_show_product),
    domes_show_manufacturer: normalizeBooleanWithDefault(
      data.domes_show_manufacturer
    ),
    domes_show_model: normalizeBooleanWithDefault(data.domes_show_model),
    domes_show_serial: normalizeBooleanWithDefault(data.domes_show_serial),
    domes_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.domes_show_mfr_warranty_exp
    ),
    domes_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.domes_show_lnd_warranty_exp
    ),
    domes_show_lnd_deductible: normalizeBooleanWithDefault(
      data.domes_show_lnd_deductible
    ),
    domes_show_price: normalizeBooleanWithDefault(data.domes_show_price),
    domes_show_quantity: normalizeBooleanWithDefault(data.domes_show_quantity),
    domes_show_patient_resp: normalizeBooleanWithDefault(
      data.domes_show_patient_resp
    ),
    domes_show_insurance_resp: normalizeBooleanWithDefault(
      data.domes_show_insurance_resp
    ),
    domes_show_managed_care_resp: normalizeBooleanWithDefault(
      data.domes_show_managed_care_resp
    ),
    domes_show_cpt_code: normalizeBooleanWithDefault(data.domes_show_cpt_code),
    domes_show_ear: normalizeBooleanWithDefault(data.domes_show_ear),
    domes_show_dome_type: normalizeBooleanWithDefault(
      data.domes_show_dome_type
    ),
    domes_show_dome_size: normalizeBooleanWithDefault(
      data.domes_show_dome_size
    ),

    // receivers
    receivers_show_product: normalizeBooleanWithDefault(
      data.receivers_show_product
    ),
    receivers_show_manufacturer: normalizeBooleanWithDefault(
      data.receivers_show_manufacturer
    ),
    receivers_show_model: normalizeBooleanWithDefault(
      data.receivers_show_model
    ),
    receivers_show_color: normalizeBooleanWithDefault(
      data.receivers_show_color
    ),
    receivers_show_serial: normalizeBooleanWithDefault(
      data.receivers_show_serial
    ),
    receivers_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.receivers_show_mfr_warranty_exp
    ),
    receivers_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.receivers_show_lnd_warranty_exp
    ),
    receivers_show_lnd_deductible: normalizeBooleanWithDefault(
      data.receivers_show_lnd_deductible
    ),
    receivers_show_price: normalizeBooleanWithDefault(
      data.receivers_show_price
    ),
    receivers_show_quantity: normalizeBooleanWithDefault(
      data.receivers_show_quantity
    ),
    receivers_show_patient_resp: normalizeBooleanWithDefault(
      data.receivers_show_patient_resp
    ),
    receivers_show_insurance_resp: normalizeBooleanWithDefault(
      data.receivers_show_insurance_resp
    ),
    receivers_show_managed_care_resp: normalizeBooleanWithDefault(
      data.receivers_show_managed_care_resp
    ),
    receivers_show_cpt_code: normalizeBooleanWithDefault(
      data.receivers_show_cpt_code
    ),
    receivers_show_ear: normalizeBooleanWithDefault(data.receivers_show_ear),
    receivers_show_gain: normalizeBooleanWithDefault(data.receivers_show_gain),
    receivers_show_length: normalizeBooleanWithDefault(
      data.receivers_show_length
    ),

    // tubes
    tubes_show_product: normalizeBooleanWithDefault(data.tubes_show_product),
    tubes_show_manufacturer: normalizeBooleanWithDefault(
      data.tubes_show_manufacturer
    ),
    tubes_show_model: normalizeBooleanWithDefault(data.tubes_show_model),
    tubes_show_serial: normalizeBooleanWithDefault(data.tubes_show_serial),
    tubes_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.tubes_show_mfr_warranty_exp
    ),
    tubes_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.tubes_show_lnd_warranty_exp
    ),
    tubes_show_lnd_deductible: normalizeBooleanWithDefault(
      data.tubes_show_lnd_deductible
    ),
    tubes_show_price: normalizeBooleanWithDefault(data.tubes_show_price),
    tubes_show_quantity: normalizeBooleanWithDefault(data.tubes_show_quantity),
    tubes_show_patient_resp: normalizeBooleanWithDefault(
      data.tubes_show_patient_resp
    ),
    tubes_show_insurance_resp: normalizeBooleanWithDefault(
      data.tubes_show_insurance_resp
    ),
    tubes_show_managed_care_resp: normalizeBooleanWithDefault(
      data.tubes_show_managed_care_resp
    ),
    tubes_show_cpt_code: normalizeBooleanWithDefault(data.tubes_show_cpt_code),
    tubes_show_ear: normalizeBooleanWithDefault(data.tubes_show_ear),

    // earmolds
    earmolds_show_product: normalizeBooleanWithDefault(
      data.earmolds_show_product
    ),
    earmolds_show_manufacturer: normalizeBooleanWithDefault(
      data.earmolds_show_manufacturer
    ),
    earmolds_show_model: normalizeBooleanWithDefault(data.earmolds_show_model),
    earmolds_show_serial: normalizeBooleanWithDefault(
      data.earmolds_show_serial
    ),
    earmolds_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.earmolds_show_mfr_warranty_exp
    ),
    earmolds_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.earmolds_show_lnd_warranty_exp
    ),
    earmolds_show_lnd_deductible: normalizeBooleanWithDefault(
      data.earmolds_show_lnd_deductible
    ),
    earmolds_show_price: normalizeBooleanWithDefault(data.earmolds_show_price),
    earmolds_show_quantity: normalizeBooleanWithDefault(
      data.earmolds_show_quantity
    ),
    earmolds_show_patient_resp: normalizeBooleanWithDefault(
      data.earmolds_show_patient_resp
    ),
    earmolds_show_insurance_resp: normalizeBooleanWithDefault(
      data.earmolds_show_insurance_resp
    ),
    earmolds_show_managed_care_resp: normalizeBooleanWithDefault(
      data.earmolds_show_managed_care_resp
    ),
    earmolds_show_cpt_code: normalizeBooleanWithDefault(
      data.earmolds_show_cpt_code
    ),
    earmolds_show_ear: normalizeBooleanWithDefault(data.earmolds_show_ear),
    earmolds_show_material: normalizeBooleanWithDefault(
      data.earmolds_show_material
    ),
    earmolds_show_canal_length: normalizeBooleanWithDefault(
      data.earmolds_show_canal_length
    ),
    earmolds_show_canal_venting: normalizeBooleanWithDefault(
      data.earmolds_show_canal_venting
    ),

    // chargers
    chargers_show_product: normalizeBooleanWithDefault(
      data.chargers_show_product
    ),
    chargers_show_manufacturer: normalizeBooleanWithDefault(
      data.chargers_show_manufacturer
    ),
    chargers_show_model: normalizeBooleanWithDefault(data.chargers_show_model),
    chargers_show_serial: normalizeBooleanWithDefault(
      data.chargers_show_serial
    ),
    chargers_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.chargers_show_mfr_warranty_exp
    ),
    chargers_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.chargers_show_lnd_warranty_exp
    ),
    chargers_show_lnd_deductible: normalizeBooleanWithDefault(
      data.chargers_show_lnd_deductible
    ),
    chargers_show_price: normalizeBooleanWithDefault(data.chargers_show_price),
    chargers_show_quantity: normalizeBooleanWithDefault(
      data.chargers_show_quantity
    ),
    chargers_show_patient_resp: normalizeBooleanWithDefault(
      data.chargers_show_patient_resp
    ),
    chargers_show_insurance_resp: normalizeBooleanWithDefault(
      data.chargers_show_insurance_resp
    ),
    chargers_show_managed_care_resp: normalizeBooleanWithDefault(
      data.chargers_show_managed_care_resp
    ),
    chargers_show_cpt_code: normalizeBooleanWithDefault(
      data.chargers_show_cpt_code
    ),

    // batteries
    batteries_show_product: normalizeBooleanWithDefault(
      data.batteries_show_product
    ),
    batteries_show_manufacturer: normalizeBooleanWithDefault(
      data.batteries_show_manufacturer
    ),
    batteries_show_model: normalizeBooleanWithDefault(
      data.batteries_show_model
    ),
    batteries_show_color: normalizeBooleanWithDefault(
      data.batteries_show_color
    ),
    batteries_show_serial: normalizeBooleanWithDefault(
      data.batteries_show_serial
    ),
    batteries_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.batteries_show_mfr_warranty_exp
    ),
    batteries_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.batteries_show_lnd_warranty_exp
    ),
    batteries_show_lnd_deductible: normalizeBooleanWithDefault(
      data.batteries_show_lnd_deductible
    ),
    batteries_show_price: normalizeBooleanWithDefault(
      data.batteries_show_price
    ),
    batteries_show_quantity: normalizeBooleanWithDefault(
      data.batteries_show_quantity
    ),
    batteries_show_patient_resp: normalizeBooleanWithDefault(
      data.batteries_show_patient_resp
    ),
    batteries_show_insurance_resp: normalizeBooleanWithDefault(
      data.batteries_show_insurance_resp
    ),
    batteries_show_managed_care_resp: normalizeBooleanWithDefault(
      data.batteries_show_managed_care_resp
    ),
    batteries_show_cpt_code: normalizeBooleanWithDefault(
      data.batteries_show_cpt_code
    ),

    // remotes
    remotes_show_product: normalizeBooleanWithDefault(
      data.remotes_show_product
    ),
    remotes_show_manufacturer: normalizeBooleanWithDefault(
      data.remotes_show_manufacturer
    ),
    remotes_show_model: normalizeBooleanWithDefault(data.remotes_show_model),
    remotes_show_serial: normalizeBooleanWithDefault(data.remotes_show_serial),
    remotes_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.remotes_show_mfr_warranty_exp
    ),
    remotes_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.remotes_show_lnd_warranty_exp
    ),
    remotes_show_lnd_deductible: normalizeBooleanWithDefault(
      data.remotes_show_lnd_deductible
    ),
    remotes_show_price: normalizeBooleanWithDefault(data.remotes_show_price),
    remotes_show_quantity: normalizeBooleanWithDefault(
      data.remotes_show_quantity
    ),
    remotes_show_patient_resp: normalizeBooleanWithDefault(
      data.remotes_show_patient_resp
    ),
    remotes_show_insurance_resp: normalizeBooleanWithDefault(
      data.remotes_show_insurance_resp
    ),
    remotes_show_managed_care_resp: normalizeBooleanWithDefault(
      data.remotes_show_managed_care_resp
    ),
    remotes_show_cpt_code: normalizeBooleanWithDefault(
      data.remotes_show_cpt_code
    ),

    // others
    others_show_product: normalizeBooleanWithDefault(data.others_show_product),
    others_show_manufacturer: normalizeBooleanWithDefault(
      data.others_show_manufacturer
    ),
    others_show_model: normalizeBooleanWithDefault(data.others_show_model),
    others_show_serial: normalizeBooleanWithDefault(data.others_show_serial),
    others_show_mfr_warranty_exp: normalizeBooleanWithDefault(
      data.others_show_mfr_warranty_exp
    ),
    others_show_lnd_warranty_exp: normalizeBooleanWithDefault(
      data.others_show_lnd_warranty_exp
    ),
    others_show_lnd_deductible: normalizeBooleanWithDefault(
      data.others_show_lnd_deductible
    ),
    others_show_price: normalizeBooleanWithDefault(data.others_show_price),
    others_show_quantity: normalizeBooleanWithDefault(
      data.others_show_quantity
    ),
    others_show_patient_resp: normalizeBooleanWithDefault(
      data.others_show_patient_resp
    ),
    others_show_insurance_resp: normalizeBooleanWithDefault(
      data.others_show_insurance_resp
    ),
    others_show_managed_care_resp: normalizeBooleanWithDefault(
      data.others_show_managed_care_resp
    ),
    others_show_cpt_code: normalizeBooleanWithDefault(
      data.others_show_cpt_code
    ),

    // services
    services_show_cpt_code: normalizeBooleanWithDefault(
      data.services_show_cpt_code
    ),
    services_show_product: normalizeBooleanWithDefault(
      data.services_show_product
    ),
    services_show_description: normalizeBooleanWithDefault(
      data.services_show_description
    ),
    services_show_price: normalizeBooleanWithDefault(data.services_show_price),
    services_show_quantity: normalizeBooleanWithDefault(
      data.services_show_quantity
    ),

    // totals
    total_show_discounts: normalizeBooleanWithDefault(
      data.total_show_discounts
    ),
    total_show_services_dispensing_fees: normalizeBooleanWithDefault(
      data.total_show_services_dispensing_fees
    ),
    total_tax: normalizeBooleanWithDefault(data.total_tax),
    total_amount: normalizeBooleanWithDefault(data.total_amount),
    total_patient_payments: normalizeBooleanWithDefault(
      data.total_patient_payments
    ),
    total_insurance_payments: normalizeBooleanWithDefault(
      data.total_insurance_payments
    ),
    amount_due_from_insurance: normalizeBooleanWithDefault(
      data.amount_due_from_insurance
    ),
    amount_due_from_patient: normalizeBooleanWithDefault(
      data.amount_due_from_patient
    ),
    balance_due: normalizeBooleanWithDefault(data.balance_due),
    total_show_cost_of_ha: normalizeBooleanWithDefault(
      data.total_show_cost_of_ha
    )
  };
}
